import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from '../layouts/Layout';
import HomePage from '../pages/Homepage';
import Territory from '../component/khamPha/territory/Territory';
import Everest from '../component/khamPha/everest/Everest';
import Ranger from '../component/khamPha/ranger/Ranger';
import Transit from '../component/khamPha/transit/Transit';
import DanhSachPage from '../pages/DanhSachPage';
import ChiTietXe from '../pages/ChiTietXe';
import TransitPage from '../pages/TransitPage';
import Explorer from '../component/khamPha/explorer/Explorer';
import BaoGiaPage from '../pages/BaoGiaPage';
import DangKyLaiThuPage from '../pages/DangKyLaiThuPage';
import DatLichBaoDuongPage from '../pages/DatLichBaoDuongPage';
import GioiThieuPage from '../pages/GioiThieuPage';
import GioiThieuDichVuPage from '../pages/GioiThieuDichVuPage';
import BaoHanhTieuChuanPage from '../pages/BaoHanhTieuChuanPage';
import PhuTungChinhHangPage from '../pages/PhuTungChinhHangPage';
import BaoHanhMoRongPage from '../pages/BaoHanhMoRongPage';
import LienHePage from '../pages/LienHePage';
import TerritoryNew from '../component/khamPha/territory/TerritoryNew';
import Mustang from '../component/khamPha/mustang/Mustang';

export default function AppRoutes() {
    return (
        <Layout>
            <Switch>
                <Route exact path="/" component={HomePage} />
                <Route path="/about" component={HomePage} />
                <Route path="/suv/territory" component={Territory} />
                <Route path="/suv/ford-everest" component={Everest} />
                <Route path="/suv/ford-explorer" component={Explorer} />
                <Route path="/trucks/ford-range" component={Ranger} />
                <Route path="/trucks/ford-transit" component={Transit} />
                <Route path="/danh-sach/:product" component={DanhSachPage} />
                <Route path="/chi-tiet/:product/:name" component={ChiTietXe} />
                <Route path="/trucks/transit/compare" component={TransitPage} />
                <Route path="/bao-gia/:name" component={BaoGiaPage} />
                <Route path="/dang-ky-lai-thu/:name" component={DangKyLaiThuPage} />
                <Route path="/dat-lich-bao-duong" component={DatLichBaoDuongPage} />
                <Route path="/gioi-thieu" component={GioiThieuPage} />
                <Route path="/gioi-thieu-dich-vu" component={GioiThieuDichVuPage} />
                <Route path="/bao-hanh-tieu-chuan" component={BaoHanhTieuChuanPage} />
                <Route path="/phu-tung-phu-kien" component={PhuTungChinhHangPage} />
                <Route path="/bao-hanh-mo-rong" component={BaoHanhMoRongPage} />
                <Route path="/lien-he" component={LienHePage} />
                <Route path="/suv/territory-new" component={TerritoryNew} />
                <Route path="/electric/ford-mustang-mach-e" component={Mustang} />
            </Switch>
        </Layout>
    );
}
